export default () => {

  // elements
  const els = {
    hero: document.querySelector('[data-banner-hero]')
  }

  const classes = {
    pageHasHero: 'page-has-hero'
  };

  if (els.hero) {
    document.body.classList.add(classes.pageHasHero)
  }
};